'use client';

import NextLink from 'next/link';
import { css } from '@bts-web/utils-style-engine';
import { TabBreadcrumbs } from '../../../../common/components/TabBreadcrumbs/TabBreadcrumbs';
import { NavigationBackButton } from '@bts-web/core-features/navigation';
import { useRedirectBasedOnRefQueryParam } from '../../../utils/useRedirectBasedOnRefQueryParam';

const navigationStyles = css({
  backgroundColor: 'screen_background.primary',
  paddingTop: 'extra_small',
  paddingBottom: 'extra_small',
  paddingInlineStart: 'small',
  paddingInlineEnd: 'small',

  lg: {
    padding: 0,
  },
});

interface AssetDetailsNavigationProps {
  assetIdentifier: string;
  assetTypeFilterName: string;
  assetTypeTranslation: string;
}

export const AssetDetailsNavigation = ({
  assetIdentifier,
  assetTypeFilterName,
  assetTypeTranslation,
}: AssetDetailsNavigationProps) => {
  const { redirectBasedOnRefQueryParam } = useRedirectBasedOnRefQueryParam();

  return (
    <div className={navigationStyles} aria-label="asset details navigation">
      <TabBreadcrumbs
        LeftComponent={
          <NavigationBackButton
            noPadding
            handleVirtualNavigation={redirectBasedOnRefQueryParam}
          />
        }
      >
        <NextLink
          href={`/discover?assetType=${encodeURIComponent(
            assetTypeFilterName,
          )}`}
        >
          {assetTypeTranslation}
        </NextLink>

        <div>{assetIdentifier}</div>
      </TabBreadcrumbs>
    </div>
  );
};
